/*
 * Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const accordionContentSchufaWbs = [
  {
    id: 0,
    heading: "Was ist der Hintergrund?",
    text:
      "Mehrere deutsche Mobilfunkanbieter haben nach Recherche der Verbraucherzentrale NRW sogenannte Positivdaten an Auskunfteien wie die SCHUFA oder CRIF weitergegeben, ohne dass die Kunden dazu eingewilligt haben. Positivdaten sind in diesem Kontext Informationen zu Vertragsabschlüssen, welche keinen Bezug zu Zahlungsverhalten oder -ausfällen haben. Aber auch diese Daten können sich auf die Kreditwürdigkeit der Kunden auswirken.\n" +
      "Das Landgericht München hat in einem ersten Urteil daher bestätigt, dass die Positivdaten nicht ohne Einverständnis an die SCHUFA / CRIF weitergegeben werden dürfen. Die bisherige Praxis der Mobilfunkanbieter verstoße gegen die Datenschutz-Grundverordnung, da hier eben keine aktive Einwilligung für diese Datenübermittlung bei den Kunden eingeholt wurde. Daraus entsteht ein Anspruch auf Schadensersatz, der bei bis zu 1.500€ liegen kann.",
  },
  {
    id: 1,
    heading: "Was ist eine Auskunftei?",
    text:
      "Eine Auskunftei ist ein Unternehmen, das Informationen über die finanzielle Situation und das Zahlungsverhalten von Verbrauchern sammelt, speichert und analysiert. Diese Informationen werden dann in Form von Bonitätsauskünften an Unternehmen und Kreditinstitute weitergegeben, um deren Entscheidungen bei der Kreditvergabe, Vermietung von Wohnungen oder anderen geschäftlichen Transaktionen zu unterstützen.\n" +
      "Beispiele für Auskunfteien sind die Schufa (Schutzgemeinschaft für allgemeine Kreditsicherung) in Deutschland und die CRIF (Credit Information Services) als internationale Auskunftei.",
  },
  {
    id: 2,
    heading: "Woher weiß ich, ob ich einen Anspruch habe?",
    text: "Es muss zunächst festgestellt werden, ob Dein Mobilfunkanbieter tatsächlich Daten an die SCHUFA / CRIF übermittelt hat. Verbraucherinnen und Verbraucher haben das Recht, mindestens einmal pro Jahr kostenlos Informationen über ihr eigenes Profil bei der SCHUFA / CRIF anzufordern. In dieser Auskunft ist erkennbar, ob die Mobilfunkanbieter deine Vertragsdaten weitergegeben haben oder nicht. Eine solche Auskunft können wir für dich einholen und diese dann entsprechend prüfen.",
  },
  {
    id: 3,
    heading: "Welche Kosten kommen auf mich zu?",
    text: "Hast du eine Rechtsschutzversicherung im Bereich Privatrechtsschutz? Dann ist das Vorgehen für dich kostenlos. Wenn du keine Rechtsschutzversicherung hast, können wir diesen Service aktuell leider nicht für dich anbieten. Du kannst dich allerdings von uns benachrichtigen lassen, sobald wir diesen Service auch ohne Rechtsschutzversicherung anbieten.",
  },
  {
    id: 4,
    heading: "Mit wie viel Schadensersatz kann ich rechnen?",
    text: "Es kann mit einer Schadensersatzsumme von bis zu 1.500€ gerechnet werden.",
  },
  {
    id: 5,
    heading: "Kann die Anspruchsdurchsetzung negative Konsequenzen auf mein Vertragsverhältnis mit meinem Mobilfunkanbieter haben?",
    text: "Nein, dein Vertragsverhältnis bleibt von der Anspruchsdurchsetzung unberührt. Der Anbieter darf dir also zum Beispiel nicht kündigen oder dergleichen.",
  },
  {
    id: 6,
    heading: "Kann die Anspruchsdurchsetzung negative Konsequenzen auf mein Bonität haben?",
    text: "Nein, die Entfernung der betroffenen Einträge kann sich unserer Einschätzung nach sogar positiv auf deine Bonität auswirken.",
  },
  {
    id: 7,
    heading: "Ich habe mehrere Mobilfunk-Verträge in den letzten Jahren abgeschlossen. Kann ich gegen alle vorgehen?",
    text: "Selbstverständlich kannst du gegen jeden Mobilfunkanbieter vorgehen, der unberechtigterweise einen Positiv-Eintrag bei der SCHUFA / CRIF verursacht hat. Registriere dich dazu einfach erst einmal mit einem Mobilfunkanbieter. Wir stellen dann eine Datenanfrage und prüfen diese natürlich direkt auf jegliche Einträge von Mobilfunkanbietern. Sollte die Prüfung der Datenauszüge ergeben, dass mehrere Einträge vorliegen, wirst du umgehend informiert und kannst dir dann entsprechend weitere Fälle gegen diese Mobilfunkanbieter anlegen.",
  },
];

export default accordionContentSchufaWbs;
